import { AxiosResponse } from "axios";
import instance from "../instance";
import {
  AllFeedback,
  FeedbackInterface,
} from "@/core/reatom/state/feedback/types";
export const feedback = async (
  oid: number,
  rating: "positive" | "negative",
  text: string
): Promise<FeedbackInterface> => {
  try {
    const res: AxiosResponse<FeedbackInterface> = await instance.post(
      `/v1/orders/${oid}/feedback`,
      {
        rating: rating === "positive" ? 1 : -1,
        text,
      }
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getFeedback = async (oid: number): Promise<AllFeedback> => {
  try {
    const res: AxiosResponse<AllFeedback> = await instance.get(
      `/v1/orders/${oid}/feedback`
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
